<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="400"
    @click:outside="closeForm()"
  >
    
    <template v-slot:activator="{ on }">
      <v-btn v-if="user" icon v-on="on">
        <v-icon>mdi-account-edit</v-icon>
      </v-btn>
      <v-btn v-else color="primary" dark v-on="on"> 
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="mt-7">
        <v-form ref="form" v-model="isValidForm" :disabled="loading">
            <v-alert 
              dense 
              outlined
              type="error" 
              :value="Boolean(serverError)"
              transition="scale-transition"
            >
              {{ serverError }}
            </v-alert>

            <v-text-field
              v-model="userObj.familyName"
              label="Фамилия *"
              @focus="serverError = ''"
              filled
              :rules="[v => !!v || 'Введите фамилию.']"
            >
            </v-text-field>
          
            <v-text-field
              v-model="userObj.firstName"
              label="Имя *"
              :rules="[v => !!v || 'Введите имя.']"
              @focus="serverError = ''"
              filled
            >
            </v-text-field>
          
            <v-text-field
              v-model="userObj.middleName"
              label="Отчество"
              @focus="serverError = ''"
              filled
            >
            </v-text-field>

            <v-text-field
              v-model="userObj.email"
              label="Email *"
              :rules="[v => !!v || 'Введите email.', v => isEmail(v) || 'Введите правильный email.']"
              :disabled="loading || Boolean(user)"
              @focus="serverError = ''"
              filled
            >
            </v-text-field>

            <v-text-field
              v-model="userObj.partnerCV.phoneNumber"
              label="Телефон"
              filled
              :prefix="phoneNumberPrefix"
              @focus="phoneNumberPrefix = '+7'"
              @blur="userObj.partnerCV.phoneNumber || (phoneNumberPrefix = '')"
              v-mask="'##########'"
              :rules="[v => !v || (v.length == 10) || 'Введите правильный номер.']"
            >
            </v-text-field>

            <v-select
              v-model="userObj.role"
              :items="roles"
              label="Роль *"
              :rules="[v => !!v || 'Выберите роль пользователя.']"
              @focus="serverError = ''"
              filled
            ></v-select>

            <v-switch 
              v-model="userObj.isActive" 
              :label="`Статус: ${userObj.isActive ? 'активен' : 'заблокирован'}`"
            >
            </v-switch>

            <v-switch 
              v-model="userObj.guestAccess.isActive" 
              :label="`Гостевой доступ: ${userObj.guestAccess.isActive ? 'включен' : 'выключен'}`"
            >
            </v-switch>
            <template v-if="userObj.guestAccess.isActive">
              <v-autocomplete
                v-model="userObj.guestAccess.site"
                :rules="[v => !!v || 'Выберите сайт']"
                :items="sitesSelectData"
                filled
              ></v-autocomplete>
              <date-picker-new
                v-model="userObj.guestAccess.startedAt"
                name="Начало периода"
              ></date-picker-new>
              <date-picker-new
                v-model="userObj.guestAccess.finishedAt"
                name="Конец периода"
              ></date-picker-new>
            </template>

            <small>* Поля обязательные для заполнения</small>
          </v-form>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save"
          :disabled="loading"
          :loading="loading"
        >Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'user-card',

  props: {
    id: String
  },
  
  data() {
    let user = this.id ? this.$store.getters['users/getUserById'](this.id) : null;
    return {
      user,
      activeMode: false,
      serverError: false,
      isValidForm: false,

      title: user ? 'Карточка пользователя' : 'Регистрация пользователя',

      userObj: user ? _.cloneDeep(user) : this.setDefaultObj(),
      phoneNumberPrefix: user ? (user.partnerCV.phoneNumber ? '+7' : '') : ''
    };
  },

  methods: {
    setDefaultObj() {
      return {
        familyName: '',
        firstName: '',
        middleName: '',
        email: '',
        role: null,
        isActive: true,
        guestAccess: {
          isActive: false,
          site: null,
          startedAt: null,
          finishedAt: null
        },
        partnerCV: {
          phoneNumber: ''
        }
      }
    },

    save() {
      this.$refs.form.validate();

      if (this.isValidForm) {
        this.$store.dispatch(this.user ? 'users/update' : 'users/signup', this.userObj)
        .then(result => {
          this.$store.dispatch('showMessage', result.message);
          this.closeForm(true);
        })
        .catch(err => {
          this.serverError = err.message;
          this.scrollUp();
        });
      }
    },

    closeForm(success = false) {
      this.scrollUp();
      this.activeMode = false;
      this.userObj = this.user ?
        (!success ? _.cloneDeep(this.user) : this.userObj) :
        this.setDefaultObj();
      this.$refs.form.resetValidation();
      this.serverError = false;
    },
  },

  computed: {
    ...mapGetters('users', ['loadingSignup', 'loadingUpdate']),
    ...mapState('users', ['roles']),
    ...mapGetters('sites', ['sitesSelectData']),
    loading() {
      return this.loadingSignup || this.loadingUpdate;
    }
  }
}
</script>